/**
 * 组织管理
 * 组织成员管理
 */
import Net from '../net';

const NAME = '[TeamApi]';
const Log = (...p) => { console['log'](NAME, ...p); }

/** === Team === **/
/** team/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.name
 * @param {*} data.tax_no
 * @param {*} data.registered_address
 * @param {*} data.contact_person
 * @param {*} data.contact_phone
 * @param {*} data.remark
*/
export async function saveTeam(data = {}) {
  Log('saveTeam data:', data)
  try {
    const res = await Net.http('team/save', { data })
    Log('saveTeam res:', res)
    return res
  } catch (err) {
    Log('saveTeam err:', err)
    throw err
  }
}

/** team/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteTeam(data = {}) {
  Log('deleteTeam data:', data)
  try {
    const res = await Net.http('team/delete', { data })
    Log('deleteTeam res:', res)
    return res
  } catch (err) {
    Log('deleteTeam err:', err)
    throw err
  }
}

/** team/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.name
 * @param {*} data.phone
 * @param {*} data.team_id
 * @param {*} data.operator_id
*/
export async function getTeamList(data = {}) {
  Log('getTeamList data:', data)
  try {
    const res = await Net.http('team/list', { data })
    Log('getTeamList res:', res)
    return res
  } catch (err) {
    Log('getTeamList err:', err)
    throw err
  }
}

/** team/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getTeamDetail(data = {}) {
  Log('getTeamDetail data:', data)
  try {
    const res = await Net.http('team/detail', { data })
    Log('getTeamDetail res:', res)
    return res
  } catch (err) {
    Log('getTeamDetail err:', err)
    throw err
  }
}

/** team-bind/batch-bind
 * @param {Object} data
 * @param {*} data.target_id
 * @param {*} data.team_ids
 * @param {*} data.target_type
 * @param {*} data.overwrite
*/
export async function bindTeam(data = {}) {
  Log('bindTeam data:', data)
  try {
    const res = await Net.http('team-bind/batch-bind', { data })
    Log('bindTeam res:', res)
    return res
  } catch (err) {
    Log('bindTeam err:', err)
    throw err
  }
}

/** team-bind/batch-unbind
 * @param {Object} data
 * @param {*} data.target_id
 * @param {*} data.team_ids
 * @param {*} data.target_type
*/
export async function unbindTeam(data = {}) {
  Log('unbindTeam data:', data)
  try {
    const res = await Net.http('team-bind/batch-unbind', { data })
    Log('unbindTeam res:', res)
    return res
  } catch (err) {
    Log('unbindTeam err:', err)
    throw err
  }
}

/** team-bind/bind-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.target_id
 * @param {*} data.target_type
*/
export async function bindTeamList(data = {}) {
  Log('bindTeamList data:', data)
  try {
    const res = await Net.http('team-bind/bind-list', { data })
    Log('bindTeamList res:', res)
    return res
  } catch (err) {
    Log('bindTeamList err:', err)
    throw err
  }
}

/** team/create-virtual-card
 * @param {Object} data
 * @param {*} data.team_id
 * @param {*} data.type
 * @param {*} data.money
 * @param {*} data.remark
 * @param {*} data.pre_pay_money
*/
export async function createTeamVirtualCard(data = {}) {
  Log('createTeamVirtualCard data:', data)
  try {
    const res = await Net.http('team/create-virtual-card', { data })
    Log('createTeamVirtualCard res:', res)
    return res
  } catch (err) {
    Log('createTeamVirtualCard err:', err)
    throw err
  }
}

/** team/get-virtual-cards
 * @param {Object} data
 * @param {*} data.team_id
*/
export async function teamVirtualCardList(data = {}) {
  Log('teamVirtualCardList data:', data)
  try {
    const res = await Net.http('team/get-virtual-cards', { data })
    Log('teamVirtualCardList res:', res)
    return res
  } catch (err) {
    Log('teamVirtualCardList err:', err)
    throw err
  }
}

/** team/set-card-status
 * @param {Object} data
 * @param {*} data.card_id
 * @param {*} data.status
*/
export async function setTeamCardStatus(data = {}) {
  Log('setTeamCardStatus data:', data)
  try {
    const res = await Net.http('team/set-card-status', { data })
    Log('setTeamCardStatus res:', res)
    return res
  } catch (err) {
    Log('setTeamCardStatus err:', err)
    throw err
  }
}

/** team/set-virtual-card-pre-pay-money
 * @param {Object} data
 * @param {*} data.card_id
 * @param {*} data.pre_pay_money
*/
export async function setTeamVirtualCardPrePayMoney(data = {}) {
  Log('setTeamVirtualCardPrePayMoney data:', data)
  try {
    const res = await Net.http('team/set-virtual-card-pre-pay-money', { data })
    Log('setTeamVirtualCardPrePayMoney res:', res)
    return res
  } catch (err) {
    Log('setTeamVirtualCardPrePayMoney err:', err)
    throw err
  }
}

/** === TeamMember === **/
/** team-member/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.team_id
 * @param {*} data.name
 * @param {*} data.phone
 * @param {*} data.vin_code
 * @param {*} data.plate_number
 * @param {*} data.vehicle_brand
 * @param {*} data.monthly_charge_limit
 * @param {*} data.use_type
 * @param {*} data.remark
*/
export async function saveTeamMember(data = {}) {
  Log('saveTeamMember data:', data)
  try {
    const res = await Net.http('team-member/save', { data })
    Log('saveTeamMember res:', res)
    return res
  } catch (err) {
    Log('saveTeamMember err:', err)
    throw err
  }
}

/** team-member/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteTeamMember(data = {}) {
  Log('deleteTeamMember data:', data)
  try {
    const res = await Net.http('team-member/delete', { data })
    Log('deleteTeamMember res:', res)
    return res
  } catch (err) {
    Log('deleteTeamMember err:', err)
    throw err
  }
}

/** team-member/batch-delete
 * @param {Object} data
 * @param {*} data.ids
*/
export async function batchDeleteTeamMember(data = {}) {
  Log('batchDeleteTeamMember data:', data)
  try {
    const res = await Net.http('team-member/batch-delete', { data })
    Log('batchDeleteTeamMember res:', res)
    return res
  } catch (err) {
    Log('batchDeleteTeamMember err:', err)
    throw err
  }
}

/** team-member/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.team_id
 * @param {*} data.name
 * @param {*} data.phone
 * @param {*} data.vin_code
 * @param {*} data.plate_number
*/
export async function getTeamMemberList(data = {}) {
  Log('getTeamMemberList data:', data)
  try {
    const res = await Net.http('team-member/list', { data })
    Log('getTeamMemberList res:', res)
    return res
  } catch (err) {
    Log('getTeamMemberList err:', err)
    throw err
  }
}

/** team-member/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getTeamMemberDetail(data = {}) {
  Log('getTeamMemberDetail data:', data)
  try {
    const res = await Net.http('team-member/detail', { data })
    Log('getTeamMemberDetail res:', res)
    return res
  } catch (err) {
    Log('getTeamMemberDetail err:', err)
    throw err
  }
}
